import React from 'react';
import { Plus } from 'lucide-react';
import './AddCardButton.css';

interface AddCardButtonProps {
    onClick: () => void;
}

export const AddCardButton: React.FC<AddCardButtonProps> = ({ onClick }) => {
    return (
        <div className="acbn-wrapper">
            <button
                type="button"
                className="acbn-button"
                onClick={onClick}
                title="Adicionar card aqui"
            >
                <Plus size={20} />
            </button>
        </div>
    );
};